/**
 * Self-Service Calculator
 *
 * Contact: dap@visana.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type Insurer = 'VISANA' | 'SANA24' | 'GALENOS';

export const Insurer = {
    Visana: 'VISANA' as Insurer,
    Sana24: 'SANA24' as Insurer,
    Galenos: 'GALENOS' as Insurer
};

